<!-- LOGO -->
<ng-container *ngIf="isAudibel; else starkeyLogo">
  <img class="logoAudibel" src="assets/logos/Audibel_Brand Logo.svg">  </ng-container>
<ng-template #starkeyLogo>
  <img class="logo" src="assets/logos/Starkey_Brand Logo.svg">
</ng-template>
